import { Injectable } from '@angular/core';
import { catchError } from 'rxjs/operators';
import { CommonHttpDataService } from 'src/app/services/http/common-http-data.service';
import { HttpService } from 'src/app/services/http/http.service';
import { Path } from 'src/app/utils/constant';

@Injectable({
  providedIn: 'root'
})
export class PrivacyPolicyService extends CommonHttpDataService {

  constructor(
    private http: HttpService
  ) { 
    super();
  }

  getPrivacyPolicy(){
    return this.http.getWithoutAuth(Path.PRIVACY_POLICY.GET_PRIVACY_POLICY).pipe(
      catchError(this.handleServiceErrors)
    );
  }


}
